var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup217(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.98,
    height: 20,
    viewBox: "0 0 24.98 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_217",
    "data-name": "Group 217",
    transform: "translate(784.138 -126.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3411",
    "data-name": "Path 3411",
    d: "M-771.617,254.246q4.916,0,9.832,0a2.528,2.528,0,0,1,2.576,1.879,2.511,2.511,0,0,1-2.426,3.128c-.058,0-.117,0-.176,0h-19.605a2.547,2.547,0,0,1-2.546-1.685,2.508,2.508,0,0,1,2.484-3.322c2.809-.007,5.618,0,8.427,0Z",
    transform: "translate(-0.029 -120.526)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3412",
    "data-name": "Path 3412",
    d: "M-774.092,131.237q-3.672,0-7.344,0a2.538,2.538,0,0,1-2.512-1.691,2.507,2.507,0,0,1,2.462-3.315c1.521-.01,3.043,0,4.564,0q5.076,0,10.152,0a2.528,2.528,0,0,1,2.546,1.761,2.5,2.5,0,0,1-2.5,3.245C-769.176,131.243-771.634,131.236-774.092,131.237Z",
    transform: "translate(-0.046)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3413",
    "data-name": "Path 3413",
    d: "M-774.13,387.211c-2.458,0-4.915.005-7.373,0a2.456,2.456,0,0,1-2.43-1.548,2.493,2.493,0,0,1,2.364-3.456c1.024-.015,2.048,0,3.072,0q5.837,0,11.674,0a2.532,2.532,0,0,1,2.552,1.753,2.507,2.507,0,0,1-2.515,3.254C-769.234,387.215-771.682,387.211-774.13,387.211Z",
    transform: "translate(0 -240.988)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup217);
export default __webpack_public_path__ + "static/media/Group 217.94595a1c51b6a67fde38c906bb8b5553.svg";
export { ForwardRef as ReactComponent };